export const dataLocal: any = {
    jp: {
        data1: [
            {
                items: [
                    {
                        img: '',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1761198945292/d3up_scene.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1761198945444/d3up_scene_M.jpg',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1761709560731/c_pc.png',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1761709561176/c_m.png',
                    },
                ],
                info: {
                    title: 'DELTA 3 Ultra Plus（3072Wh）',
                    desc: '3,072Wh 容量、最大11,264Whまで容量拡張対応\n分電盤に接続して家庭用蓄電池として利用可能\n4つのAC出力ポートを2分割で制御できるスマート機能\n4つの充電方法 × 1.6時間の急速充電\n5年間の保証付き',
                    pointRate: 5,
                    productId: '14803254935919',
                    variantId: '52291938976111',
                    showBtnBuy: false,
                    linkMore: 'https://jp.ecoflow.com/products/delta-3-ultra-plus-portable-station?variant=52291938976111',
                    link_buy: '購入手続きへ',
                },
                direction: 'rtl',
            },
            {
                items: [
                    {
                        img: '',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1761198945000/d3u_scene.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1761198944782/d3u_scene_M.jpg',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1761709560731/c_pc.png',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1761709561176/c_m.png',
                    },
                ],
                info: {
                    title: 'DELTA 3 Ultra（3072Wh）	',
                    desc: '定格3,000W出力・3,072Wh大容量\n27%軽量化 × キャスター＆ハンドル付き\n暮らしも仕事もこれ1台、多彩な10ポート出力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
                    pointRate: 5,
                    productId: '14803254870383',
                    variantId: '52291943104879',
                    showBtnBuy: false,
                    linkMore: 'https://jp.ecoflow.com/products/delta-3-ultra-portable-station?variant=52291943104879',
                    link_buy: '購入手続きへ',
                },
            },
        ],
        data2: [
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    title: 'DELTA 3 Ultra（3072Wh） +\n600Ｗ Alternator Charger			',
                    subtitle: '',
                    desc: '定格3,000W出力・3,072Wh大容量\n27%軽量化 × キャスター＆ハンドル付き\n走行中に約5.7時間でフル充電可能',
                    pointRate: 5,
                    productId: '14803254870383',
                    variantId: '52291941990767',
                    showBtnBuy: false,
                    linkMore: 'https://jp.ecoflow.com/products/delta-3-ultra-portable-station?variant=52291941990767',
                    link_buy: '購入手続きへ',
                },
            },
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    title: 'DELTA 3 Ultra（3072Wh） +\n400Ｗ ソーラーパネル			',
                    subtitle: '',
                    desc: '定格3,000W出力・3,072Wh大容量\n27%軽量化 × キャスター＆ハンドル付き\n最大800Wのソーラー入力で約4.8時間でフル充電可能',
                    pointRate: 5,
                    productId: '14803254870383',
                    variantId: '52291941925231',
                    showBtnBuy: false,
                    linkMore: 'https://jp.ecoflow.com/products/delta-3-ultra-portable-station?variant=52291941925231',
                    link_buy: '購入手続きへ',
                },
            },
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    title: 'DELTA 3 Ultra（3072Wh） + Wave 3',
                    subtitle: '',
                    desc: '定格3,000W出力・3,072Wh大容量\n27%軽量化 × キャスター＆ハンドル付き\n暮らしも仕事もこれ1台、多彩な10ポート出力',
                    pointRate: 5,
                    productId: '14803254870383',
                    variantId: '52291942023535',
                    showBtnBuy: false,
                    linkMore: 'https://jp.ecoflow.com/products/delta-3-ultra-portable-station?variant=52291942023535',
                    link_buy: '購入手続きへ',
                },
            },
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    title: 'DELTA 3 Ultra Plus（3072Wh） +\n1000Ｗ Alternator Charger',
                    subtitle: '',
                    desc: '定格3,000W出力・3,072Wh大容量\n分電盤に接続して家庭用蓄電池として利用可能\n走行中に約3.1時間でフル充電可能',
                    pointRate: 5,
                    productId: '14803254935919',
                    variantId: '52291939271023',
                    showBtnBuy: false,
                    linkMore: 'https://jp.ecoflow.com/products/delta-3-ultra-plus-portable-station?variant=52291939271023',
                    link_buy: '購入手続きへ',
                },
            },
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    title: 'DELTA 3 Ultra Plus（3072Wh） + DELTA 3 Max 専用エクストラバッテリー + 400Ｗ ソーラーパネル',
                    subtitle: '',
                    desc: '定格3,000W出力・3,072Wh大容量\n分電盤に接続して家庭用蓄電池として利用可能\n最大11,264Whまで容量拡張対応\n最大1600Wのソーラー入力で約2.4時間でフル充電可能',
                    pointRate: 5,
                    productId: '14803254935919',
                    variantId: '52291939303791',
                    showBtnBuy: false,
                    linkMore: 'https://jp.ecoflow.com/products/delta-3-ultra-plus-portable-station?variant=52291939303791',
                    link_buy: '購入手続きへ',
                },
            },
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    title: 'DELTA 3 Ultra Plus（3072Wh） + DELTA 3 Max 専用エクストラバッテリー',
                    subtitle: '',
                    desc: '定格3,000W出力・3,072Wh大容量\n27%軽量化 × キャスター＆ハンドル付き\n最大11,264Whまで容量拡張対応',
                    pointRate: 5,
                    productId: '14803254935919',
                    variantId: '52291939008879',
                    showBtnBuy: false,
                    linkMore: 'https://jp.ecoflow.com/products/delta-3-ultra-plus-portable-station?variant=52291939008879',
                    link_buy: '購入手続きへ',
                },
            },
        ],
    },
};
